import { useState } from 'react';

interface EscrowRequest {
  id: number;
  service: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  createdBy: string;
  createdAt: string;
  status: string;
}

interface EscrowRequestTableProps {
  requests: EscrowRequest[];
  onDelete: (id: number) => void;
}

export function EscrowRequestTable({ requests, onDelete }: EscrowRequestTableProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');

  const filteredRequests = requests.filter((req:any) => {
    const matchesSearch = searchTerm ?
      req.erw_first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.erw_last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.erw_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.erw_service?.toLowerCase().includes(searchTerm.toLowerCase()) :true

    const matchesStatus = filterStatus === 'All' || req.status === filterStatus;

    return matchesSearch && matchesStatus;
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'In Progress':
        return 'bg-blue-100 text-blue-800';
      case 'Completed':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm escrow-requests-table-card">
      <div className="p-6 border-b border-gray-200">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <input
              type="text"
              placeholder="Search by name, email, or service..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option>All</option>
            <option>Pending</option>
            <option>In Progress</option>
            <option>Completed</option>
          </select>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">ID</th>
              <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">Service</th>
              <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">Name</th>
              <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">Contact</th>
              <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">Created At</th>
              {/* <th className="px-6 py-[8px] text-left text-sm font-medium text-gray-700">Actions</th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredRequests.length === 0 ? (
              <tr>
                <td colSpan={8} className="px-6 py-8 text-center text-gray-500">
                  No escrow requests found
                </td>
              </tr>
            ) : (
              filteredRequests.map((request:any) => (
                <tr key={request.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">#{request.id}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{request.service}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">
                    {request.erw_first_name} {request.erw_last_name}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="text-gray-900">{request.erw_email}</div>
                    <div className="text-gray-500">{request.erw_phone}</div>
                  </td>
                  {/* <td className="px-6 py-4 text-sm">
                    <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(request.status)}`}>
                      {request.status}
                    </span>
                  </td> */}
                  <td className="px-6 py-4 text-sm text-gray-500">{formatDate(request.erw_created_at)}</td>
                  {/* <td className="px-6 py-4 text-sm">
                    <div className="flex gap-2">
                      <button className="text-blue-600 bg-transparent border-0 hover:text-blue-800">View</button>
                      <button
                        onClick={() => onDelete(request.id)}
                        className="text-red-600 bg-transparent border-0 hover:text-red-800"
                      >
                        Delete
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <p className="text-sm text-gray-600">
          Showing {filteredRequests.length} of {requests.length} requests
        </p>
      </div>
    </div>
  );
}
